import { Shield, Truck, RefreshCw, Lock, CheckCircle } from "lucide-react";

export const TrustBadges = () => {
  const badges = [
    {
      icon: Lock,
      text: "Veilig betalen",
      description: "SSL beveiligde checkout"
    },
    {
      icon: Truck,
      text: "Gratis verzending",
      description: "Vanaf €50"
    },
    {
      icon: RefreshCw,
      text: "14 dagen retour",
      description: "Niet goed, geld terug"
    },
    {
      icon: Shield,
      text: "100% Natuurlijk",
      description: "Premium kwaliteit"
    },
    {
      icon: CheckCircle,
      text: "NVWA Geregistreerd",
      description: "Officieel erkend"
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 py-6">
      {badges.map((badge, index) => {
        const IconComponent = badge.icon;
        return (
          <div
            key={index}
            className="flex flex-col items-center text-center p-4 rounded-lg bg-muted/30"
          >
            <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center mb-2">
              <IconComponent className="w-6 h-6 text-gold" />
            </div>
            <p className="text-sm font-semibold text-foreground">{badge.text}</p>
            <p className="text-xs text-muted-foreground mt-1">{badge.description}</p>
          </div>
        );
      })}
    </div>
  );
};
